import { APP_CONFIG } from '@/config/env';
import { useNavigate } from 'react-router-dom';

export const LogoElement = () => {
  const navigate = useNavigate();
  const [preText, highlightText, ...afterTexts] = APP_CONFIG.title.split(' ');
  return (
    <div onClick={() => navigate('/')}>
      <div className="text-base font-[DingTalkJinBuTi] group-data-[collapsible=compact]:text-center cursor-pointer">
        <span>{preText} </span>
        <span className="text-blue-600">{highlightText} </span>
        <span className="group-data-[collapsible=compact]:hidden">{afterTexts.join(' ')}</span>
      </div>
    </div>
  );
};
